import { useMutation } from "react-query";
import api from "../../client";
import { InstitutionRanking } from "../../types/institution-ranking";

const deleteData = async (
  id: string | undefined,
): Promise<InstitutionRanking> => {
  const { data } = await api.delete(`/institution-ranking/${id}`);

  return data;
};

export const useDeleteInstitutionRanking = () => {
  return useMutation((id: string | undefined) => {
    return deleteData(id);
  });
};
